import { Button } from "@mui/material";
import { TeamGoalConfigurationFragment } from "apps/web/src/types";
import { createSimpleExport } from "apps/web/src/utils/excel/export";
import { format } from "date-fns";
import React from "react";

interface DownloadButtonProps {
  data: readonly TeamGoalConfigurationFragment[];
  teamName: string;
}

interface CSVData {
  team: string;
  date_exported: string;
  athlete: string;
  position: string;
  goal_name: string;
  goal_start_date: string;
  goal_category: string;
  count_completed_goal_task_to_date: number;
  count_assigned_goal_task_to_date: number;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ data, teamName }) => {
  const downloadXLSX = async () => {
    const serializedData = data.map(
      (goal): CSVData => ({
        team: teamName,
        date_exported: new Date().toISOString().split("T")[0],
        athlete: `${goal.athlete?.lastName}, ${goal.athlete?.firstName}`,
        position: goal?.athlete?.position?.name || "",
        goal_name: goal.name,
        goal_start_date: goal.startDate as string,
        goal_category: `${goal.category.defaultEmoji} ${goal.category.name}`,
        count_completed_goal_task_to_date: goal.completedGoalCount,
        count_assigned_goal_task_to_date: goal.totalGoalCount,
      })
    );
    const headers = Object.keys(serializedData[0]);
    const columns = headers.map(header => ({
      header,
      key: header,
      width: Math.max(header.length, ...serializedData.map(row => row[header as keyof CSVData]?.toString().length || 10)) + 2,
    }));
    const rows = serializedData.map(row => headers.map(header => row[header as keyof CSVData]));
    const fileName = `goals_for_${teamName}_export_date_${format(new Date(), "yyyy-MM-dd")}`;

    await createSimpleExport({ columns, rows, fileName, options: { sheetName: "Sheet 1" } });
  };

  return (
    <Button variant="text" size="small" onClick={downloadXLSX} aria-label="Export Goals" disabled={data.length < 1}>
      Export
    </Button>
  );
};

export default DownloadButton;
